<template>
    <div class="page">
        <RTip />
        <RQuery v-if="app_type == 2" />
        <div class="rules-content">
            <div class="title">已启用规则</div>
            <div class="rule-box">
                <RuleBlock  v-for="(item, index) in rulesList.slice(0,1)" :rules="item" :key="index" @del="delRule" @start="staRule" />
                <div class="add-rule" @click="openAddBox(false)">
                    <img src="http://cdn.chinachdu.com/webStatic/pay-platform/add.png" />
                    <span>添加分账规则</span>
                </div>
            </div>
            <div class="title m-t-30">未启用规则</div>
            <div class="rule-box">
                <RuleBlock v-for="(item, index) in rulesList.slice(1)" :rules="item" :key="index" @del="delRule" @start="staRule" />
            </div>
        </div>
        <AddRule :id="id" ref="addbox" />
    </div>
</template>

<script>
import RTip from '@set-up/components/r-tip.vue';
import RQuery from '@set-up/components/r-query.vue';
import RuleBlock from '@set-up/components/rule-block.vue';
import AddRule from '@set-up/components/add-rule.vue';
import { mapActions, mapState } from 'vuex';
export default {
  components: { RTip, RuleBlock,RQuery,AddRule},
  name: 'rule',
  provide() {
    return {
      app_type: this.app_type, // 区分是汇付宝还是其他
      openAddBox: this.openAddBox,
    };
  },
  computed: {
    ...mapState({
      rulesList: (state) => state.rules.rulesList,
    }),
  },
  data() {
    return {
      app_type: 1,
      id: '', // 编辑规则时，传入组价的id
    };
  },
  created() {
    this.getRulesAll({ mainMerchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
  },
  methods: {
    ...mapActions('rules', ['getRulesAll', 'deleteRule', 'startRule']),
    // 此处id为规则的id
    openAddBox(id) {
      //let clear = !(id == this.id);
      this.id = id;
      this.$nextTick(() => {
         //this.$refs.addbox.openDialog(clear);
        this.$refs.addbox.openDialog()
      });
    },
    //删除规则
    delRule(ruleId) {
      this.deleteRule({ ruleId: ruleId })
        .then(() => {
          this.$message.success('删除成功');
          this.getRulesAll({ mainMerchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    //启用规则
    staRule(ruleId,startType) {
      startType===1?startType=2:startType=1;
      let data={
        ruleId: ruleId,
        mainMerchant:JSON.parse(localStorage.getItem('merchantInfo')).hyUid,
        startType:startType
      }
      this.startRule(data)
        .then(() => {
          this.getRulesAll({ mainMerchant: JSON.parse(localStorage.getItem('merchantInfo')).hyUid });
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.rules-content {
  background-color: #fff;
  margin-top: 10px;
  padding: 15px 15px 15px 5px;
  border-radius: 5px;
  .title {
    font-size: 16px;
    color: #333;
    padding-left: 10px;
    line-height: 20px;
    border-left: 3px solid #4359b7;
    margin-left: 10px;
  }
  .rule-box {
    .flex_layout(@justify: flex-start);
    flex-wrap: wrap;
    margin-top: 9px;
    .add-rule {
      .flex_layout();
      width: 480px;
      height: 203px;
      margin-top: 10px;
      margin-left: 10px;
      color: #4359b7;
      font-size: 14px;
      background-color: #fcfcfc;
      cursor: pointer;
      span {
        margin-left: 5px;
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.m-t-30 {
  margin-top: 30px;
}
</style>
